import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupIntersect3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBooleanGroupIntersect3"><Path d="M11.5 8H16V12.5H14.5V9.5H11.5V8Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M8 2H22V16H16V22H2V8H8V2ZM9.5 14.5H20.5V3.5H9.5V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupIntersect3;
